<template>
  <div @click="handleClick">
    <!-- Render whatever is inside -->
    <slot />
  </div>
</template>

<script>
export default {
  name: "TripleClick",
  props: {
    delay: {
      type: Number,
      default: 1000 // max ms between clicks
    }
  },
  data() {
    return {
      clickCount: 0,
      clickTimer: null
    }
  },
  methods: {
    handleClick(event) {
      this.clickCount++

      if (this.clickTimer) clearTimeout(this.clickTimer)

      this.clickTimer = setTimeout(() => {
        this.clickCount = 0
      }, this.delay)

      if (this.clickCount === 3) {
        this.$emit("triple-click", event)
        this.clickCount = 0
        clearTimeout(this.clickTimer)
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.clickTimer)
  }
}
</script>

<style scoped>
div {
  cursor: pointer;
}
</style>
